import Vue from 'vue'



import vMap from './map.vue';

import vMeteorologicalLayer from './switchLayer/meteorologicalLayer.vue';
import vMeteoLegendTable from './switchLayer/meteorological/meteoLegendTable.vue';
import vAltitudeControll from './switchLayer/meteorological/altitudeControll';
import vTimeControll from './switchLayer/meteorological/timeControll';
import vMapSwitch from './mapSwitch';
import vSwitchLayer from './switchLayer';
import vKeepWatch from './keepWatch';

import vFunMeunBar from './keepWatch/FunMeunBar';
import vShowPlanByIcao from './keepWatch/showPlanByIcao';
import vMeasure from './keepWatch/measure';
import vSwichWatchAir from './switchLayer/swichWatchAir';
import vMapMeunBar from './keepWatch/MapMeunBar/MapMeunBar';
import vDetailMap from './detailMap';

import vComMap from './comMap';
import vPlanrele from './planrele';




let comComponent = {
    vMap,
    vMeteorologicalLayer,
    vMeteoLegendTable,
    vAltitudeControll,
    vTimeControll,
    vMapSwitch,
    vSwitchLayer,
    vComMap,
    vPlanrele,
    vKeepWatch,
    vMeasure,

    vFunMeunBar,
    vShowPlanByIcao,
    vSwichWatchAir,
    vMapMeunBar,
    vDetailMap
}


for (let k in comComponent) {
    Vue.component(k, comComponent[k])
}